import { Component, OnInit, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { api } from 'src/app/@shared/services/api';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';
import { environment } from 'src/environments/environment';
import { CommonService } from 'src/app/@shared/services/common.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { MessageService } from 'src/app/@shared/message/message.service';

@Component({
  selector: 'app-settlement',
  templateUrl: './settlement.component.html',
  styleUrls: ['./settlement.component.css']
})
export class SettlementComponent implements OnInit {

  public api = api;
  public env = environment;
  public data: any;
  public modalData: any;
  public modalDataIndex: any;
  private subs: Subscription[] = [];
  private uId: any;
  formData!: FormGroup;
  balanceSheetFormData!: FormGroup;
  public eventTypes: any[] = [];
  submitted = false;
  modalRef?: BsModalRef;
  pointAcc: any;

  constructor(public service: WebserviceService,
    private _common: CommonService,
    private _message: MessageService,
    private fb: FormBuilder,
    public router: Router,
    private modalService: BsModalService,
    public actRoute: ActivatedRoute) {
    this.pointAcc = (localStorage.getItem(`${this.env.panel}pointAcc`)) ? localStorage.getItem(`${this.env.panel}pointAcc`) : '';
  }

  ngOnInit(): void {
    this.uId = this.actRoute.snapshot.paramMap.get('uid');
    this.formData = this.fb.group({
      settlement_user_id: [''],
      settlement_amount: [0],
      settlement_note: [''],
      settlement_side: [''],
      parent_password: [''],
      deposit_chips: [false],
    });
    this.balanceSheetFormData = this.fb.group({
      start_date: [null, Validators.required],
      end_date: [null, Validators.required],
    })
    this.getData('', 'init');
  }

  getServices(): IbaseService<any> {
    return this.service;
  }

  getData(e: any, key: any = '') {
    if (this.router.url.includes('settlement')) {
      this.getSettlementData(e);
    } else {
      this.getBalanceSheetData(e, key);
    }
  }

  openModal(template: TemplateRef<any>, index: any, item: any, side: any) {
    this.modalData = item;
    this.modalDataIndex = index;
    if (this.pointAcc == 'false') {
      this.formData.patchValue({
        settlement_user_id: item?.user_id,
        settlement_amount: item?.transfer_amount,
        settlement_side: side,
        deposit_chips: false,
      });
      this.modalRef = this.modalService.show(template, Object.assign({}, { class: `${this.env.modalClass}` }));
    } else if (this.pointAcc == 'true' && item?.role_id != 4) {
      this.getBankSattlementData(template, item?.user_id);
    }
  }

  getBankSattlementData(template: TemplateRef<any>, id: any) {
    const sub1 = this.getServices().Get(`${this.env.baseUrl + this.api.user}/${id}${this.api.getBankSettlement}`).subscribe(
      (res) => {
        if (res.status == true) {
          this.formData.patchValue({
            settlement_user_id: res?.data?.user?.id,
            settlement_amount: res?.data?.user_settlement_amount[0]?.transfer_amount,
          });
          this.modalRef = this.modalService.show(template);
        } else {
          this._common.checkForForceChangePassword(res);
        }
      },
      (err) => {
        console.log(err);
      });
    this.subs.push(sub1)
  }

  getBalanceSheetData(url: any, key: any = '') {
    let apiurl = url == '' ? `${this.env.baseUrl + this.api.user}/${this.actRoute.snapshot.paramMap.get('uid')}${(this.router.url.includes('settlement')) ? this.api.settlement : this.api.balanceSheet}` : url;
    const sub1 = this.getServices().Post(apiurl, (key == 'init') ? '' : this._common.JSON_to_formData(this.balanceSheetFormData.value)).subscribe(
      (res) => {
        if (res.status == true) {
          this.commonFun(res);
        } else {
          this._common.checkForForceChangePassword(res);
        }
      },
      (err) => {
        console.log(err);
      });
    this.subs.push(sub1)
  }

  getSettlementData(url: any) {
    let apiurl = url == '' ? `${this.env.baseUrl + this.api.user}/${this.actRoute.snapshot.paramMap.get('uid')}${(this.router.url.includes('settlement')) ? this.api.settlement : this.api.balanceSheet}` : url;
    const sub1 = this.getServices().Get(apiurl).subscribe(
      (res) => {
        if (res.status == true) {
          this.commonFun(res);
        } else {
          this._common.checkForForceChangePassword(res);
        }
      },
      (err) => {
        console.log(err);
      });
    this.subs.push(sub1)
  }

  commonFun(res: any) {
    res.data.settlementsMinusCollection.forEach((element: any) => {
      element.transfer_amount = -parseFloat(element.transfer_amount)
      res.data.totalMinus += parseFloat(element.transfer_amount);
    });

    res.data.settlementsPlusCollection.forEach((element: any) => {
      res.data.totalPlus += parseFloat(element.transfer_amount);
      element.transfer_amount = parseFloat(element.transfer_amount)
    });
    // res.data.totalPlus += parseFloat(res?.data?.parentPlEntry?.transfer_amount) + parseFloat(res?.data?.ownPlEntry?.transfer_commission_in) + parseFloat(res?.data?.ownPlEntry?.transfer_amount) + parseFloat(res?.data?.myRunningPl);
    // res.data.totalPlus += parseFloat(res?.data?.parentPlEntry?.transfer_amount) + parseFloat(res?.data?.ownPlEntry?.transfer_amount);
    // this.data = res.data;

    // if (res.data?.childrenCash?.transfer_amount)
    //   res.data.totalMinus -= parseFloat(res.data?.childrenCash?.transfer_amount)

    res.data.totalPlus += (this.checkPlus(res?.data?.parentPlEntry?.transfer_amount)) + (this.checkPlus(res?.data?.ownPlEntry?.transfer_amount));
    res.data.totalMinus += (this.checkMinus(res?.data?.parentPlEntry?.transfer_amount)) + (this.checkMinus(res?.data?.ownPlEntry?.transfer_amount));

    if (res.data?.childrenCash?.transfer_amount) {
      res.data.totalPlus += (this.checkMinus(res.data?.childrenCash?.transfer_amount))
      res.data.totalMinus += (this.checkPlus(res.data?.childrenCash?.transfer_amount))
    }
    this.data = res.data;

    if (this.data?.is_parent_password_required == 0) {
      this.formData.removeControl('parent_password');
    }
  }

  checkPlus(e: any) {
    return e >= 0 ? parseFloat(e) : 0;
  }
  checkMinus(e: any) {
    return e < 0 ? -parseFloat(e) : 0;
  }

  trackByIndex(index: number, obj: any): any {
    return index;
  }

  closeModal() {
    this.modalRef?.hide();
    this.resetForm();
  }

  resetForm() {
    this.formData.patchValue({
      settlement_user_id: '',
      settlement_amount: 0,
      settlement_note: '',
      settlement_side: '',
      parent_password: '',
      deposit_chips: false,
    });
  }

  onSubmit() {

    // stop here if form is invalid
    if (this.formData.invalid) {
      return;
    }
    this.submitted = true;
    let req: any;
    let satUrl: any;
    let uid: any
    if (this.pointAcc == 'true') {
      uid = this.formData.value.settlement_user_id
      satUrl = this.api.updateBankSettlement;
      req = {
        'amount': this.formData.value.settlement_amount,
        'note': this.formData.value.settlement_note
      }
    } else {
      req = this.formData.value;
      if (this.formData.value.deposit_chips == true) {
        req['deposit_chips'] = 'on';
        // this.formData.patchValue({
        //   deposit_chips: 'on'
        // });
      } else {
        delete req['deposit_chips'];
        // this.formData.removeControl('deposit_chips');
      }
      uid = this.actRoute.snapshot.paramMap.get('uid');
      satUrl = this.api.updateSettlement;
    }
    // console.log(req); return;

    const sub2 = this.getServices().Post(`${this.env.baseUrl + this.api.user}/${uid + satUrl}`, this._common.JSON_to_formData(req)).subscribe(
      (res) => {
        if (res.status == true) {
          this.modalRef?.hide();
          this._message.succmessage(res?.data?.message);

          if (this.formData.value.settlement_side == 1) {
            // console.log(111);

            this.data.settlementsPlusCollection[this.modalDataIndex].transfer_amount -= parseFloat(this.formData.value.settlement_amount)
          } else {
            this.data.settlementsMinusCollection[this.modalDataIndex].transfer_amount -= this.formData.value.settlement_amount
          }
          this.resetForm();
          // this.getData('');
        } else {
          if (res.error.code == 1003) {
            this._common.checkForForceChangePassword(res);
          } else {
            this._message.errmessage(res?.data?.message);
            // this._message.errmessage(res?.error?.message);
          }
        }
        this.submitted = false;

      },
      (err) => {
        console.log(err);
        this.submitted = false;
      });
    this.subs.push(sub2)
  }

  changePage(e: any) {
    if (e.label != this.data.transactions.current_page) {
      this.getData(e.url);
    }
  }

  fixedTwoDec(e: any) {
    return Number(e).toFixed(2)
  }

  ngDoCheck() {
    if (this.uId != this.actRoute.snapshot.paramMap.get('uid')) {
      this.uId = this.actRoute.snapshot.paramMap.get('uid');
      if (this.balanceSheetFormData.value.start_date != null && this.balanceSheetFormData.value.end_date != null) {
        this.getData('');
      } else {
        this.balanceSheetFormData = this.fb.group({
          start_date: [null, Validators.required],
          end_date: [null, Validators.required],
        })
        this.getData('', 'init');
      }
    }

  }

  ngOnDestroy() {
    this.subs.forEach((s) => s.unsubscribe());
  }

}
